import React from 'react';

import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import PopupPortal from 'apps/auth/components/common/Popup/PopupPortal';
import FeeTextPopup from 'apps/auth/components/common/send/popups/FeeTextPopup';
import { FEE_TEXT_POPUP, REQUEST_CREATE_PRECHECK_POPUP } from 'apps/auth/constants/ComponentNames';
import { REQUEST_FORM_NAME } from 'apps/auth/constants/formName';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import PrecheckPopup from './PrecheckPopup';
import { REQUEST_DELIVERY_METHODS } from './RequestConstants';

const CreateRequestPopups = (props) => {
    const { requestToPaysendInfo } = usePageMessages();

    const customHandleClose = () => {
        if (props?.setScreen) {
            props.setScreen(REQUEST_DELIVERY_METHODS);
        }
        if (props.popupRef?.current) {
            props.popupRef.current?.close();
        } else {
            props.togglePopup(false);
        }
    };

    const getPrecheckPopupComponent = () => {
        return (
            <PrecheckPopup
                handleClose={customHandleClose}
                submitRef={props.submitRef}
                popupRef={props.popupRef}
                formName={REQUEST_FORM_NAME}
                setPopup={props.setPopup}
            />
        );
    };

    const getFeeTextPopupComponent = () => {
        return (
            <FeeTextPopup
                text={requestToPaysendInfo}
                isComment={true}
                isShowTerms={false}
                closeHandler={() => {
                    props.setPopup(REQUEST_CREATE_PRECHECK_POPUP);
                    props.popupRef?.current?.open();
                }}
            />
        );
    };
    if (props.popup === REQUEST_CREATE_PRECHECK_POPUP) {
        return <PopupNew getPopupComponent={getPrecheckPopupComponent} ref={props.popupRef} as={PopupPortal} />;
    }
    if (props.popup === FEE_TEXT_POPUP) {
        return <PopupNew getPopupComponent={getFeeTextPopupComponent} ref={props.popupRef} as={PopupPortal} />;
    }
    return null;
};
export default React.memo(CreateRequestPopups);
